import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    // Slider home
    const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

    if (homeSlideshow) {
        let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        Swiper.use([ A11y, Autoplay, EffectFade, Navigation, Pagination ]);
        
        let config = {
            grabCursor : 'true',
            speed: 700,
            loop : true,

            effect : 'fade',
            fadeEffect: {
                crossFade: true,
            },

            // Navigation (arrow)
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },

            // Pagination (bullet)
            pagination: {
                el: '.c-pagination__bullets',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(dataSlideAuto === '1'){
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        if(nbSlides > 1) {
            let swiperHome = new Swiper('.home-slideshow .swiper-container', config);

            if (dataSlideAuto === "1") {
                let boutonPlayPause = document.getElementById("js-boutonAutoplay");
                let iconPause = boutonPlayPause.querySelector(".nav-swiper-autoplay__icon--pause");
                let iconPlay = boutonPlayPause.querySelector(".nav-swiper-autoplay__icon--play");
 
              // Initial state adjustment
                if (swiperHome.autoplay.running) {
                    iconPause.classList.remove("hidden");
                    iconPlay.classList.add("hidden");
                } else {
                    iconPause.classList.add("hidden");
                    iconPlay.classList.remove("hidden");
                }
 
              boutonPlayPause.addEventListener("click", function () {
                if (swiperHome.autoplay.running) {
                  swiperHome.autoplay.stop();
 
                  boutonPlayPause.classList.remove("nav-swiper-autoplay--play");
                  boutonPlayPause.classList.add("nav-swiper-autoplay--pause");
                  iconPause.classList.add("hidden");
                  iconPlay.classList.remove("hidden");
                } else {
                  swiperHome.autoplay.start();
 
                  boutonPlayPause.classList.remove("nav-swiper-autoplay--pause");
                  boutonPlayPause.classList.add("nav-swiper-autoplay--play");
                  iconPause.classList.remove("hidden");
                  iconPlay.classList.add("hidden");
                }
              });
            }
        }
    }

    // Slider news
  const postsSlideshow =
  document.querySelector(".news .swiper-container") !== null;

    if (postsSlideshow) {
        let postsSlides = document.querySelectorAll(
            ".news .swiper-container .swiper-slide"
        ).length;

        Swiper.use([Navigation, A11y]);

        let postsConfig = {
            effect: "slide",
            grabCursor: "true",
            speed: 700,
            loop: false,

            breakpoints: {
            1201: {
                allowTouchMove: false,
                spaceBetween: 30,
                slidesPerView: 3,
            },

            961: {
                allowTouchMove: false,
                spaceBetween: 20,
                slidesPerView: 3,
            },

            641: {
                allowTouchMove: false,
                spaceBetween: 20,
                slidesPerView: 2,
            },

            0: {
                allowTouchMove: true,
                spaceBetween: 20,
                slidesPerView: 1,
            },
            },

            navigation: {
            nextEl: `.news__navigation__button--next`,
            prevEl: `.news__navigation__button--prev`,
            },

            a11y: {
            enabled: true,
            prevSlideMessage: "Diapositive précédente",
            nextSlideMessage: "Diapositive suivante",
            slideLabelMessage: "{{index}} / {{slidesLength}}", // default
            },
        };

        const newsNav = document.querySelector(".news__navigation");
        let swiperPosts = new Swiper(".news .swiper-container", postsConfig);

        if (window.innerWidth > 960) {
            if (postsSlides <= 3) {
                newsNav.classList.add("disable");
            }
        } 

        if (window.innerWidth > 640 && window.innerWidth < 961) {
            if (postsSlides <= 2) {
                newsNav.classList.add("disable");
            }
        }

        if (window.innerWidth > 0 && window.innerWidth < 641) {
            if (postsSlides <= 1) {
                newsNav.classList.add("disable");
            }
        }
    }

        // Slider Events
  const eventsSlideshow =
  document.querySelector(".events .swiper-container") !== null;

    if (eventsSlideshow) {
        let eventsSlides = document.querySelectorAll(
            ".events .swiper-container .swiper-slide"
        ).length;

        Swiper.use([Navigation, A11y]);

        let eventsConfig = {
            effect: "slide",
            grabCursor: "true",
            speed: 700,
            loop: false,

            breakpoints: {
            1201: {
                allowTouchMove: false,
                spaceBetween: 30,
                slidesPerView: 3,
            },

            961: {
                allowTouchMove: false,
                spaceBetween: 20,
                slidesPerView: 2,
            },

            641: {
                allowTouchMove: false,
                spaceBetween: 20,
                slidesPerView: 2,
            },

            0: {
                allowTouchMove: true,
                spaceBetween: 20,
                slidesPerView: 1,
            },
            },

            navigation: {
                nextEl: `.events__navigation__button--next`,
                prevEl: `.events__navigation__button--prev`,
            },

            a11y: {
            enabled: true,
            prevSlideMessage: "Diapositive précédente",
            nextSlideMessage: "Diapositive suivante",
            slideLabelMessage: "{{index}} / {{slidesLength}}", // default
            },
        };

        const eventsNav = document.querySelector(".events__navigation");
        
        let swiperEvents = new Swiper(".events .swiper-container", eventsConfig);

        if (window.innerWidth > 1200) {
            
            if (eventsSlides <= 3) {
                eventsNav.classList.add("disable");
            }
        }

        if (window.innerWidth > 960 && window.innerWidth < 1201) {
            if (eventsSlides <= 2) {
                eventsNav.classList.add("disable");
            }
        }

        if (window.innerWidth > 640 && window.innerWidth < 961) {
            if (eventsSlides <= 2) {
                eventsNav.classList.add("disable");
            }
        }

        if (window.innerWidth > 0 && window.innerWidth < 641) {
            if (eventsSlides <= 1) {
                eventsNav.classList.add("disable");
            }
        }
    }
}
